type Config = {
  TITLE: string;
  DESCRIPTION: string;
  DOMAIN: string;
  OG_IMAGE_URL: string;
  JOINING_BONUS: number;
  JOINING_PLAY_PASSES: number;
  MAX_TAPS: number;
  TAP_REFILL_TIME: number;
  MAX_GAME_PASSES_PER_TAP_CLAIM: number;
  MAX_MINING_DURATION: number;
  MINING_MESSAGE: string;
  MINING_BUTTON_TEXT: string;
  INVITE_FRIENDS_BUTTON_TEXT: string;
  CRYPTO_CURRENCY_NAME: string;
  CRYPTO_CURRENCY_FULL_NAME: string;
  TOKEN_MINING_RATE: number;

  // Mining related constants
  MINING_DURATION: number;
  MINING_REWARD_PER_SECOND: number;
  MINING_TOTAL_REWARD: number;
  MINING_STORAGE_KEY: string;
  IS_AUTO_CLAIMED: boolean;

  // Auto-farming release configuration
  AUTO_FARMING_ENABLED: boolean;
  AUTO_FARMING_RELEASE_COUNTDOWN: boolean;
  AUTO_FARMING_RELEASE_DATE: string; // ISO format date string
  AUTO_FARMING_COUNTDOWN_STORAGE_KEY: string;
  AUTO_FARMING_COUNTDOWN_MESSAGE: string;

  // Maintenance configuration
  UNDER_MAINTENANCE: boolean;

  TG_BOT_USERNAME: string;
  TG_CHANNEL_JOIN_LINK: string;
  TG_APP_START_LINK: string;

  LOCAL_DATA_URL: string;
  DATA_URL: string;
  DASHBOARD_API_URL: string;
};

const config: Config = {
  TITLE: "Fameverse",
  DESCRIPTION:
    "Earn tokens through tapping, mining, and completing tasks in the crypto game.",
  DOMAIN: "tokens.fameverse.io",
  OG_IMAGE_URL: "",
  JOINING_BONUS: 1500,
  JOINING_PLAY_PASSES: 2,
  MAX_TAPS: 250,
  TAP_REFILL_TIME: 12,
  MAX_GAME_PASSES_PER_TAP_CLAIM: 1,
  MAX_MINING_DURATION: 3,
  MINING_MESSAGE: "Mining",
  MINING_BUTTON_TEXT: "Start mining",
  INVITE_FRIENDS_BUTTON_TEXT: "Invite a friend",
  CRYPTO_CURRENCY_NAME: "FAMVpts",
  CRYPTO_CURRENCY_FULL_NAME: "Fameverse",
  TOKEN_MINING_RATE: 0.0001,

  // Mining configuration
  // MINING_DURATION: 20 * 1000, // 20 seconds in milliseconds (for testing)
  MINING_DURATION: 6 * 60 * 60 * 1000, // 6 hours in milliseconds (production)
  MINING_REWARD_PER_SECOND: 1, // 1 FAMV per second
  MINING_TOTAL_REWARD: 6 * 60 * 60, // 21600 FAMV (1 FAMV per second for 6 hours)
  MINING_STORAGE_KEY: "mining-state-v1",
  IS_AUTO_CLAIMED: false,

  // Auto-farming release configuration
  AUTO_FARMING_ENABLED: true, // Set to false initially, will be true after countdown
  AUTO_FARMING_RELEASE_COUNTDOWN: true, // Set to true to show the countdown banner
  // Fixed release date for all users (May 10, 2025 at 06:44 UTC)
  AUTO_FARMING_RELEASE_DATE: "2025-05-10T06:44:00.000Z",
  AUTO_FARMING_COUNTDOWN_STORAGE_KEY: "auto-farming-countdown-v1",
  AUTO_FARMING_COUNTDOWN_MESSAGE: "Auto Mining Coming Soon!",

  // Maintenance configuration
  UNDER_MAINTENANCE: false,

  TG_BOT_USERNAME: "fameverse_token_bot",
  TG_CHANNEL_JOIN_LINK: "https://t.me/thefameverseannouncement",
  TG_APP_START_LINK: "https://t.me/fameverse_token_bot?startapp=ref-",
  LOCAL_DATA_URL: "http://localhost:8000/clicker/",
  DATA_URL: "https://tokens-backend.fameverse.io/clicker/",
  DASHBOARD_API_URL: "https://tokens-backend.fameverse.io",
};

export const LEVELS = {
  BEGINNER: "Level 1",
  INTERMEDIATE: "Level 2",
  ADVANCED: "Level 3",
  EXPERT: "Level 4",
  MASTER: "Level 5",
  GRANDMASTER: "Level 6",
} as const;

export const XP_PER_LEVEL = {
  BEGINNER: 1000,
  INTERMEDIATE: 2000,
  ADVANCED: 3000,
  EXPERT: 4000,
} as const;

export const initData =
  "query_id=AAHdF6IQAAAAAN0XohDhrOrc&user=%7B%22id%22%3A123456789%2C%22first_name%22%3A%22Test%22%2C%22last_name%22%3A%22User%22%2C%22username%22%3A%22testuser%22%2C%22language_code%22%3A%22en%22%7D&auth_date=1677651261&hash=c91a83b60f7ad42d7cba45ddc6e54b4ebf74987ae67a6ab5a5b200c48f56c613";

export default config;
